export const BUD_WAN_FETCH_REQUEST = 'BUD_WAN_FETCH_REQUEST';
export const BUD_WAN_FETCH_SUCCESS = 'BUD_WAN_FETCH_SUCCESS';

export const BUD_INTERNET_FETCH_REQUEST = 'BUD_INTERNET_FETCH_REQUEST';
export const BUD_INTERNET_FETCH_SUCCESS = 'BUD_INTERNET_FETCH_SUCCESS';

export const BUD_WAN_INBOUND_REQUEST = 'BUD_WAN_INBOUND_REQUEST';
export const BUD_WAN_INBOUND_SUCCESS = 'BUD_WAN_INBOUND_SUCCESS';
export const BUD_WAN_INBOUND_FAILURE = 'BUD_WAN_INBOUND_FAILURE';

export const BUD_WAN_OUTBOUND_REQUEST = 'BUD_WAN_OUTBOUND_REQUEST';
export const BUD_WAN_OUTBOUND_SUCCESS = 'BUD_WAN_OUTBOUND_SUCCESS';
export const BUD_WAN_OUTBOUND_FAILURE = 'BUD_WAN_OUTBOUND_FAILURE';

export const BUD_INTERNET_INBOUND_REQUEST = 'BUD_INTERNET_INBOUND_REQUEST';
export const BUD_INTERNET_INBOUND_SUCCESS = 'BUD_INTERNET_INBOUND_SUCCESS';
export const BUD_INTERNET_INBOUND_FAILURE = 'BUD_INTERNET_INBOUND_FAILURE';

export const BUD_INTERNET_OUTBOUND_REQUEST = 'BUD_INTERNET_OUTBOUND_REQUEST';
export const BUD_INTERNET_OUTBOUND_SUCCESS = 'BUD_INTERNET_OUTBOUND_SUCCESS';
export const BUD_INTERNET_OUTBOUND_FAILURE = 'BUD_INTERNET_OUTBOUND_FAILURE';

export const BUD_SITES_SEARCH_REQUEST = 'BUD_SITES_SEARCH_REQUEST';
export const BUD_SITES_SEARCH_SUCCESS = 'BUD_SITES_SEARCH_SUCCESS';
export const BUD_SITES_SEARCH_FAILURE = 'BUD_SITES_SEARCH_FAILURE';

export const BUD_SITES_INDEX_REQUEST = 'BUD_SITES_INDEX_REQUEST';
export const BUD_SITES_INDEX_SUCCESS = 'BUD_SITES_INDEX_SUCCESS';
export const BUD_SITES_INDEX_FAILURE = 'BUD_SITES_INDEX_FAILURE';

export const BUD_BANDWIDTH_FETCH_REQUEST = 'BUD_BANDWIDTH_FETCH_REQUEST';
export const BUD_BANDWIDTH_FETCH_SUCCESS = 'BUD_BANDWIDTH_FETCH_SUCCESS';
export const BUD_BANDWIDTH_FETCH_FAILURE = 'BUD_BANDWIDTH_FETCH_FAILURE';
